module.exports = __webpack_public_path__ + "img/mood_board_simple_trigger.2c9bb641.jpg";